import {
    ReactNode, useCallback, useEffect, useRef, useState,
} from 'react';
import { InternalOverlay } from 'react-rainbow-components';
import {
    useOutsideClick,
    useWindowResize,
    useWindowScrolling,
} from '@rainbow-modules/hooks';
import positionResolver from './resolver';
import {
    DropDown,
    Header,
    StyledButton,
} from './styled';

interface Props {
    title?: string;
    children: ReactNode;
}

const SeeDetailsDropdown = ({
    title = 'Pricing details',
    children,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef<{ htmlElementRef: HTMLElement }>();
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggle = useCallback(() => setIsOpen((open) => !open), []);
    const close = useCallback(() => setIsOpen(false), []);

    useOutsideClick(dropdownRef, close, isOpen);
    useWindowResize(close, isOpen);
    useWindowScrolling(close, isOpen);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        document.addEventListener('scroll', close, true);

        return () => {
            document.removeEventListener('scroll', close, true);
        };
    }, [isOpen, close]);

    return (
        <>
            <StyledButton
                ref={buttonRef}
                variant="base"
                borderRadius="semi-square"
                onClick={toggle}
            >
                See details
            </StyledButton>
            <InternalOverlay
                isVisible={isOpen}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                triggerElementRef={() => buttonRef.current?.htmlElementRef}
                positionResolver={positionResolver}
            >
                <DropDown ref={dropdownRef}>
                    <Header>{title}</Header>
                    {children}
                </DropDown>
            </InternalOverlay>
        </>
    );
};

export default SeeDetailsDropdown;
